import { render, staticRenderFns } from "./Shooter.vue?vue&type=template&id=53eb6076&"
import script from "./Shooter.vue?vue&type=script&lang=js&"
export * from "./Shooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports